export const MigrosbankTheme = {
  name: 'Migrosbank Theme',
  themeId: 'migrosbank',
  colors: {
    brand: {
      primary: {
        100: '#144B3C'
      },
      secondary: {
        100: '#6B7A6C'
      },
      accent: {
        100: '#6B7A6C'
      },
      text: {
        100: '#6B7A6C'
      },
      negative: {
        100: '#D80519'
      },
      positive: {
        100: '#14873C'
      },
      highlight: {
        100: '#D9007E'
      },
      altHighlight: {
        100: '#D9007E'
      },
      backgroundHighlight: {
        100: '#EDE9F0'
      },
      grayout: {
        100: '#F5F5F5'
      },
      alternative: {
        100: '#4F1F68'
      }
    }
  },
  backgrounds: {
    tile: 'linear-gradient(135deg, rgba(217, 0, 126, 1) 0%, rgba(255, 140, 40, 1) 100%)'
  },
  fonts: {
    families: {
      text: 'Migros Bank Kievit, arial, sans-serif',
      condensed: 'Migros Bank Kievit, arial, sans-serif',
      notes: 'Migros Bank Kievit, arial, sans-serif',
      heading: 'Migros Bank Kievit, arial, sans-serif',
      subHeading: 'Migros Bank Kievit, arial, sans-serif',
      display: 'Migros Bank Kievit, arial, sans-serif',
      articleText: 'Migros Bank Kievit, arial, sans-serif',
      articleHeading: 'Migros Bank Kievit, arial, sans-serif'
    }
  }
};